export default __webpack_public_path__ + "img/fleet.cd8a8241.png";